import { launchApp } from '@didi/webx-js'
import { getPubData, addH5UrlParams } from '../../utils'
import JumpChain from '../jump/jump-chain'
import { trackEvent } from '../../trackEvent/index'
/**
 * @description 拉端
 * @author changlingfei
 */

function autoLaunchApp (data) {
  const { dchn, invokePriority, invokeMode } = data
  const phone = getPubData('phone') || ''
  const keyboardToken = getPubData('keyboardToken') || ''
  // 埋点：拉端动作
  trackEvent('userteam_ad_zj_diaoqi_bt')
  const params = {
    phone,
    launchAppDchn: dchn,
    env: process.env.WEBX_ENV,
    invokePriority,
    invokeMode,
    keyboardToken
  }
  launchApp(params)
    .then(() => {
      // 埋点：拉端成功
      trackEvent('userteam_ad_zj_diaoqi_success_bt')
      console.log('拉端成功')
    })
    .catch(() => {
      console.log('拉端失败')
    })
}

function handleLaunchApp (eventData = {}) {
  const jumpChain = JumpChain(eventData, 5000)
  jumpChain.jumpLink(link => {
    jumpPage(link)
  })
  jumpChain.start()
}

function jumpPage (url) {
  window.location.href = addH5UrlParams(url)
}

export default function (eventData = {}) {
  const actionAttr = eventData.actionAttr || {}
  const { launchAppType, clientLink, miniLink, androidDownloadLink, iosDownloadLink } = actionAttr
  let goToLink = getPubData('goToLink') || null
  // 兼容落地页手填四个链接的版本
  if (goToLink) {
    handleLaunchApp(goToLink)
    return
  }
  // dchn版本，兼容老版本
  if (launchAppType === 'dchn') {
    // 当拉端事件是页面加载后立即触发的事件时，给该拉端事件打上曝光拉端的标记
    if (eventData.eventName === 'mounted') {
      actionAttr.invokeMode = 'expose'
    }
    autoLaunchApp(actionAttr)
    return
  }
  // 自定义四个跳转链接版本
  if (launchAppType === 'customize') {
    goToLink = {
      link_mp: miniLink,
      link_app: clientLink,
      link_android_download: androidDownloadLink,
      link_ios_download: iosDownloadLink
    }
    handleLaunchApp(goToLink)
  }
}
